import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaymentHistoryCard = ({ payment }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const getPaymentStatusColor = (status) => {
    const colors = {
      success: 'bg-success/10 text-success border-success/20',
      pending: 'bg-warning/10 text-warning border-warning/20',
      failed: 'bg-destructive/10 text-destructive border-destructive/20'
    };
    return colors?.[status] || colors?.pending;
  };

  const getPaymentIcon = (method) => {
    const icons = {
      card: 'CreditCard',
      upi: 'Smartphone',
      wallet: 'Wallet',
      cash: 'Banknote'
    };
    return icons?.[method] || 'CreditCard';
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 hover:shadow-lg transition-all duration-300">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name={getPaymentIcon(payment?.method)} size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-sm font-semibold text-foreground">
              {payment?.bookingId}
            </p>
            <p className="text-xs text-muted-foreground">
              {formatDate(payment?.date)}
            </p>
          </div>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getPaymentStatusColor(payment?.status)} self-start sm:self-auto`}>
          {payment?.status?.charAt(0)?.toUpperCase() + payment?.status?.slice(1)}
        </span>
      </div>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-muted-foreground">Amount Paid</p>
          <p className="text-xl font-bold text-foreground whitespace-nowrap">
            ₹{payment?.amount?.toLocaleString('en-IN')}
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          iconPosition="left"
        >
          Receipt
        </Button>
      </div>
    </div>
  );
};

export default PaymentHistoryCard;